import { useQuery } from '@tanstack/react-query'
import { getPurseDistributions } from '@/queries/program_purses/requests'
import { PURSE_KEYS } from '@/queries/program_purses/keys'

type UsePurseDistributionsQueryParams = {
  programId: number
  purseId: number
}

export const usePurseDistributionsQuery = ({
  programId,
  purseId,
}: UsePurseDistributionsQueryParams) => {
  return useQuery({
    queryKey: PURSE_KEYS.PURSE_DISTRIBUTIONS(purseId, programId),
    queryFn: () => getPurseDistributions({ programId, purseId }),
  })
}
